__turbopack_context__.v({
  "container": "D_nraq_container",
});
